import { Injectable } from '@angular/core';
import { AppInjectorService } from 'src/app/app-injector.service'
import { HttpService } from '../crosscutting/http-service/http.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  httpService: HttpService
  constructor() {
    const injector = AppInjectorService.getInstance().getInjector();
    this.httpService = injector.get(HttpService)
  }
}
